import { EntitiesListingDataItem } from '.';


/**
 * Given an entityId and the root node of the entity tree, find the node from the tree that has the same entityId as the provided entityId
 */
export const findSelectedEntityNode = (
    entityId: string | undefined,
    root: EntitiesListingDataItem | undefined,
): EntitiesListingDataItem | undefined => {
    if (entityId && root) {
        if (root.actualValue.entity.entityId === entityId) {
            return root;
        }
        if (root.displayValue.children) {
            // eslint-disable-next-line no-restricted-syntax
            for (const child of root.displayValue.children) {
                const result = findSelectedEntityNode(entityId, child);
                if (result) {
                    return result;
                }
            }
        }
    }

    return undefined;
};
